import { render, staticRenderFns } from "./ProfileImageCarousel.vue?vue&type=template&id=138b1eda&"
import script from "./ProfileImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ProfileImageCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProfileImageCarousel.vue?vue&type=style&index=0&id=138b1eda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports